import { render } from "./ObjectCreateForm.vue?vue&type=template&id=1654d047"
import script from "./ObjectCreateForm.vue?vue&type=script&lang=js"
export * from "./ObjectCreateForm.vue?vue&type=script&lang=js"

import "./ObjectCreateForm.vue?vue&type=style&index=0&id=1654d047&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__